import { Authorize } from "../../models/authorize.model";
import { Category } from "../../models/category.model";
import { Company } from "../../models/company.mode";
import { Item } from "../../models/item.model";
import { MenuItem } from "../../models/menu.item.mode";
import { WorkItem } from "../../models/service.model";
import { ItemServiceRate } from "../../models/service.rate.model";


export class SelectedTenantId {
  static readonly type = "[OrdePortalGlobal] Get Tenant Id";

  constructor(public payload: string | undefined) {
  }
}
export class SelectedLocationId {
  static readonly type = "[OrdePortalGlobal] Get Location Id";

  constructor(public payload: string | undefined) {
  }
}

export class GetClientId {
  static readonly type = "[OrdePortalGlobal] Get Client Id";

  constructor() {
  }
}

export class GetOrganizationUnitId {
  static readonly type = "[OrdePortalGlobal] Get OrganizationUnit Id";

  constructor() {
  }
}

export class SetConnectionId {
  static readonly type = "[OrdePortalGlobal] Set Connection Id";

  constructor(public payload: string | undefined) {
  }
}


export class SelectedDistributionLane {
  static readonly type = "[Layout] Set Distribution Lane";

  constructor(public payload: string[] | undefined) {
  }
}

export class SetDistributionLaneId {
  static readonly type = "[OrdePortalGlobal] Set Distribution Lane Id";

  constructor(public payload: string | undefined) {
  }
}

export class Login {
  static readonly type = '[OrdePortalGlobal] login user';
  constructor(public payload: Authorize | undefined) {}
}
export class SelectedCategory {
  static readonly type = '[OrdePortalGlobal] Selected Category';
  constructor(public payload: Category | undefined) {}
}
export class SelectedItem {
  static readonly type = '[OrdePortalGlobal] Selected Item';
  constructor(public payload: Item | undefined) {}
}
export class SelectedWorkItem {
  static readonly type = '[OrdePortalGlobal] Selected Work Item';
  constructor(public payload: WorkItem | undefined) {}
}
export class SelectedItemServiceRate {
  static readonly type = '[OrdePortalGlobal] Selected Item Service Rate';
  constructor(public payload: ItemServiceRate | undefined) {}
}
export class SelectedMenuItems {
  static readonly type = '[OrdePortalGlobal] Selected Menu Item';
  constructor(public payload: MenuItem[] | undefined) {}
}

export class SelectedLocation {
  static readonly type = '[OrdePortalGlobal] Selected Location';
  constructor(public payload: Location | undefined) {}
}

export class SelectedCompany {
  static readonly type = '[OrdePortalGlobal] Selected Company';
  constructor(public payload: Company | undefined) {}
}
export class SelectedUser{
  static readonly type = '[OrdePortalGlobal] Selected User';
  constructor(public payload: any | undefined) {}
}
export class SelectedAccount{
  static readonly type = '[OrdePortalGlobal] Selected User';
  constructor(public payload: any | undefined) {}
}

export class SelectedPaymentMethod{
  static readonly type = '[OrdePortalGlobal] Selected Payment Method';
  constructor(public payload: any | undefined) {}
}
export class SelectedOrder{
  static readonly type = '[OrdePortalGlobal] Selected Order';
  constructor(public payload: any | undefined) {}
}
export class AllowedLocations{
  static readonly type = '[OrdePortalGlobal] Allowed Locations';
  constructor(public payload: any | undefined) {}
}

export class SelectedVoucher{
  static readonly type = '[OrdePortalGlobal] Selected Voucher';
  constructor(public payload: any | undefined) {}
}
export class SelectedCustomer{
  static readonly type = '[OrdePortalGlobal] Selected Customer';
  constructor(public payload: any | undefined) {}
}
export class SelectedOrderNote{
  static readonly type = '[OrdePortalGlobal] Selected Order Note';
  constructor(public payload: any | undefined) {}
}
export class SelectedUserPin{
  static readonly type = '[OrdePortalGlobal] Selected User Pin';
  constructor(public payload: any | undefined) {}
}

export class SelectedOrderStatus{
  static readonly type = '[OrdePortalGlobal] Selected Order Status';
  constructor(public payload: any | undefined) {}
}